import React, { Component } from 'react';
import './YouTubePlayer.css';

class YouTubePlayer extends Component {
  constructor(props) {
    super(props);
    this.playerRef = React.createRef();
    this.state = {
      player: null
    };
  }

  componentDidMount() {
    this.loadYouTubeAPI();
  }

  componentDidUpdate(prevProps) {
    const { videoId, isOpen } = this.props;
    
    // Only reinitialize if videoId or isOpen changed
    if (prevProps.videoId !== videoId || prevProps.isOpen !== isOpen) {
      if (isOpen && videoId) {
        this.initializePlayer();
      }
    }
  }

  componentWillUnmount() {
    this.destroyPlayer();
  }

  loadYouTubeAPI = () => {
    // Load YouTube IFrame API only once
    if (!window.YT) {
      const tag = document.createElement('script');
      tag.src = 'https://www.youtube.com/iframe_api';
      const firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
      
      // Set up callback for when API is ready
      window.onYouTubeIframeAPIReady = () => {
        this.initializePlayer();
      };
    } else if (window.YT.Player) {
      // API already loaded
      this.initializePlayer();
    }
  }

  initializePlayer = () => {
    const { videoId, isOpen, startTime } = this.props;
    
    if (!window.YT || !this.playerRef.current || !videoId || !isOpen) {
      return;
    }

    // Destroy existing player first
    this.destroyPlayer();

    // Create new player
    const newPlayer = new window.YT.Player(this.playerRef.current, {
      height: '360',
      width: '640',
      videoId: videoId,
      playerVars: {
        autoplay: 1,
        modestbranding: 1,
        rel: 0,
        showinfo: 0,
        controls: 1,
        start: startTime || 0
      }
    });

    this.setState({ player: newPlayer });
  }

  destroyPlayer = () => {
    const { player } = this.state;
    if (player && player.destroy) {
      player.destroy();
      this.setState({ player: null });
    }
  }

  handleOpenInBrowser = () => {
    const { videoUrl, startTime } = this.props;
    if (videoUrl) {
      let url = videoUrl;
      if (startTime && startTime > 0) {
        // Add start time parameter to the URL
        const separator = url.includes('?') ? '&' : '?';
        url = `${url}${separator}t=${startTime}s`;
      }
      window.open(url, '_blank');
    }
  }

  render() {
    const { videoId, isOpen, onClose, videoUrl, startTime, thought, author } = this.props;

    if (!isOpen) return null;

    return (
      <div className="youtube-player-overlay" onClick={onClose}>
        <div className="youtube-player-container" onClick={(e) => e.stopPropagation()}>
          <button className="close-button" onClick={onClose}>
            ×
          </button>
          
          {/* Thought and Author Information */}
          {(thought || author) && (
            <div className="video-info">
              {thought && (
                <h3 className="video-thought">{thought}</h3>
              )}
              {author && (
                <p className="video-author">— {author}</p>
              )}
            </div>
          )}
          
          <div className="video-container">
            {videoId && (
              <iframe
                ref={this.playerRef}
                className="youtube-player"
                width="640"
                height="360"
                src={`https://www.youtube.com/embed/${videoId}?autoplay=1&modestbranding=1&rel=0&showinfo=0&controls=1&start=${startTime || 0}`}
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            )}
            <div className="video-actions">
              {videoUrl && (
                <button 
                  className="open-in-browser-btn"
                  onClick={this.handleOpenInBrowser}
                >
                  Having issues? Open in browser
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default YouTubePlayer;
